const getAmountDiscount = (record) => {
  if (record?.quantity && record?.discount_amount)
    return record.discount_amount;
};

const getAmountWTax = (record) => {
  if (record?.quantity && record?.unit_price_w_tax)
    return record.quantity * record.unit_price_w_tax;
};

const getDiscount = (record) => {
  if (record?.discount_rate)
    return (record.discount_rate * 100).toFixed(2).toString() + " %";
};

const saleLineView = {
  model: "sale.line",
  form_action: [],
  table_action: ["open"],
  selectable: null,
  limit: 50,
  pagination: [],
  fields: {
    sale: { type: "many2one", model: "sale.sale" },
    "sale.sale_date": { type: "date" },
    product: { type: "many2one", model: "product.product", required: true },
    "product.code": { type: "char", readOnly: true },
    unit: { type: "many2one", model: "product.uom" },
    quantity: { type: "integer", required: true },
    base_price: { type: "numeric", readOnly: true },
    unit_price: { type: "numeric", readOnly: true },
    unit_price_w_tax: { type: "numeric", readOnly: true },
    description: { type: "char" },
    discount_amount: {
      type: "numeric",
      readOnly: true,
      function: getAmountDiscount,
    },
    discount_rate: {
      type: "char",
      readOnly: true,
      function: getDiscount,
    },
    amount: { type: "numeric", readOnly: true },
    amount_w_tax: {
      type: "numeric",
      readOnly: true,
      function: getAmountWTax,
    },
    "origin.appointment_date": { type: "char", readOnly: true },
    origin: { type: "many2one", readOnly: true },
  },
  list: [
    { name: "sale", width: "20%" },
    { name: "sale.sale_date", width: "20%" },
    { name: "product", width: "20%" },
    { name: "origin.appointment_date", width: "20%" },
    { name: "quantity", width: "20%" },
    { name: "base_price", width: "20%" },
    { name: "discount_rate", width: "20%" },
    { name: "unit_price_w_tax", width: "20%" },
    { name: "amount_w_tax", width: "20%" },
  ],
  form: [],
};

export default saleLineView;
